import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=2452b610&scoped=true&"
import script from "./ContactView.vue?vue&type=script&lang=js&"
export * from "./ContactView.vue?vue&type=script&lang=js&"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=2452b610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452b610",
  null
  
)

export default component.exports